<template>
  <v-flex xs12>
    <v-card class="py-4 px-2">
      <v-layout row wrap justify-end v-if="!isView && !isLocalAdmin && initDone">
        <div class="d-inline-flex">
          <div class="pr-3"><v-btn @click="showImportModal = !showImportModal" class="primary mx-0 mb-4">{{$lang.actions.importCompany}}</v-btn></div>
        </div>
      </v-layout>

      <v-flex px-3 pt-2 pb-4 v-if="!isView && !isLocalAdmin && initDone">
        <hr>
      </v-flex>

      <v-flex xs12 pb-3 px-3 v-if="err">
        <v-alert :value="true" type="error">{{err}}</v-alert>
      </v-flex>
      <v-flex xs12 pb-3 px-3 v-if="success">
        <v-alert :value="true" type="success">{{success}}</v-alert>
      </v-flex>
      <v-form v-model="valid">
        <v-flex xs12 sm10 md7 mx-3>
          <v-autocomplete
            :items="companies"
            :label="$lang.actions.selectCompany"
            :readonly="isView"
            v-model="companyId"
            item-text="name"
            item-value="id"
            required
            :loading="companyLoading"
            :rules="[v => !!v || `${$lang.errors.missingCompany}`]"
          />
        </v-flex>
        <v-flex xs12 sm10 md7 mx-3>
          <v-text-field
            required
            :readonly="isView"
            :label="$lang.labels.templateName"
            v-model="templateName"
            :rules="[v => !!v || `${$lang.errors.missingTemplateName}`]"
          />
        </v-flex>
        <v-flex xs12 md7 mx-3>
          <v-text-field
            :label="$lang.labels.numberOfPrints"
            :readonly="isView"
            v-model="noOfPrints"
            required
            :rules="[v => !!v || `${$lang.errors.missingNoPrints}`]"
          />
        </v-flex>
        <v-layout row wrap justify-space-between align-center v-if="!isView && !isClone">
          <v-flex xs12 md7 mx-3>
            <v-autocomplete
              :items="Object.keys(types)"
              :label="$lang.actions.selectPrintTemplateType"
              :readonly="isView"
              v-model="type"
              required
              :loading="typesLoading"
              :rules="[v => !!v || `${$lang.errors.missingPrintTemplateType}`]"
            />
          </v-flex>

          <v-flex mx-3>
            <v-autocomplete
              :items="templates"
              :label="$lang.actions.selectTemplateImport"
              v-model="templateId"
              item-text="templateName"
              item-value="id"
              :disabled="templates.length === 0"
            />
            <v-btn @click="populate" :disabled="templateId === null" class="primary mx-3 my-0">{{$lang.actions.populate}}</v-btn>
          </v-flex>
        </v-layout>
        <v-flex xs12 md7 mx-3 v-if="type === 'mainaway'">
          <v-autocomplete
            :label="$lang.labels.mainawayTemplate"
            :items="mainaway"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingMainaway}`]"
          />
        </v-flex>
        <v-flex xs12 md7 mx-3 v-if="type === 'unpaidbill'">
          <v-autocomplete
            :label="$lang.labels.unpaidBillTemplate"
            :items="unpaidBill"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingUnpaidBill}`]"
          />
        </v-flex>
        <v-flex xs12 md7 mx-3 v-if="type === 'invoice'">
          <v-autocomplete
            :label="$lang.labels.itemTemplate"
            :items="item"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingItemTemplate}`]"
          />
        </v-flex>
        <v-flex xs12>
          <v-flex xs12 md7 mx-3 v-if="type === 'invoice'">
            <v-autocomplete
              :label="$lang.labels.taxTemplate"
              :items="tax"
              item-text="name"
              item-value="name"
              v-model="taxContent"
              required
              :readonly="isView"
              :rules="[() => contents !== null || `${$lang.errors.missingTaxTemplate}`]"
            />
          </v-flex>
        </v-flex>
        <v-flex xs12 md7 mx-3 v-if="type === 'label'">
          <v-autocomplete
            :label="$lang.labels.labelTemplate"
            :items="label"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingLabelTemplate}`]"
          />
        </v-flex>
        <v-flex xs12 md7 mx-3 v-if="type === 'kitchen'">
          <v-autocomplete
            :label="$lang.labels.kitchenTemplate"
            :items="kitchen"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingKitchenTemplate}`]"
          />
        </v-flex>
        <v-flex xs12 md7 mx-3 v-if="type === 'driver'">
          <v-autocomplete
            :label="$lang.labels.driverTemplate"
            :items="driver"
            item-text="name"
            item-value="name"
            v-model="contents"
            required
            :readonly="isView"
            :rules="[() => contents !== null || `${$lang.errors.missingDriverTemplate}`]"
          />
        </v-flex>
        <v-btn class="primary mx-4 mb-2" @click="addPrefix" :disabled="editPrefix" v-if="!isView">{{$lang.actions.prefixLines}}</v-btn>
        <h3 class="mx-4" v-if="isView && prefixLines.length !== 0">{{$lang.header.prefixLines}}:</h3>
        <v-flex xs12 px-3>
          <div class="v-table__overflow">
            <table class="v-datatable v-table theme--light">
              <tbody>
                <tr
                  v-for="(prefix, index) in prefixLines"
                  :key="index">
                  <template v-if="prefix.isEdit">
                    <td class="move-row" v-if="!isView" />
                    <td class="pb-2">
                      <v-text-field
                        v-if="tempPrefix.content !== 'image'"
                        v-model="tempPrefix.fontHeight"
                        :disabled="['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(tempPrefix.content)"
                        :label="$lang.labels.fontHeight"
                        min="0"
                        type="number"
                        class="min-w"
                        required
                        hide-details
                      />
                    </td>
                    <td class="pb-2">
                      <v-select
                        v-if="tempPrefix.content !== 'image'"
                        v-model="tempPrefix.fontStyle"
                        :items="fontStyles"
                        :disabled="['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(tempPrefix.content)"
                        :label="$lang.labels.fontStyle"
                        class="min-w"
                        required
                        hide-details
                      />
                    <template v-else>
                      <v-text-field
                        ref="fileTextField"
                        v-model="tempPrefix.filename"
                        label="choose_file"
                        prepend-icon="attach_file"
                        single-line
                        hide-details
                        required
                        class="min-w"
                        @click="startInput('prefixFileInput')"
                      />
                      <input style="display: none;" type="file" accept="image/*" ref="prefixFileInput" @change="onFileChange('tempPrefix', $event)">
                    </template>
                    </td>
                    <td class="pb-2">
                      <v-combobox
                        :label="$lang.labels.content"
                        class="min-w"
                        :items="lineChoices"
                        :search-input.sync="tempPrefix.content"
                        required
                        v-model="tempPrefix.content"
                        hide-details
                      />
                    </td>
                    <td class="actions px-0">
                      <v-btn
                        class="primary elevation-1"
                        :disabled="!tempPrefix.content ||
                          (tempPrefix.content !== 'image' && (!tempPrefix.fontHeight || !tempPrefix.fontStyle)) ||
                          (tempPrefix.content === 'image' && !tempPrefix.filename)"
                        @click="savePrefixEdit(prefix)">{{$lang.actions.save}}</v-btn>
                      <v-btn class="error ml-0 elevation-1" @click="closePrefixEdit(prefix)">{{$lang.actions.cancel}}</v-btn>
                    </td>
                  </template>
                  <template v-else>
                    <td class="move-row" v-if="!isView">
                      <div v-if="prefixLines.length >= 2">
                        <v-icon @click="moveUp(prefixLines, index)" v-if="index !== 0">keyboard_arrow_up</v-icon>
                        <v-icon @click="moveDown(prefixLines, index)" v-if="index != prefixLines.length - 1">keyboard_arrow_down</v-icon>
                      </div>
                    </td>
                    <td v-if="prefix.content !== 'image'">{{ prefix.fontHeight }}</td>
                    <td :colspan="prefix.content !== 'image' ? 1 : 2">{{ prefix.content !== 'image' ? prefix.fontStyle : prefix.filename }}</td>
                    <td>{{ prefix.content }}</td>
                    <td class="actions px-0" v-if="!isView">
                      <v-btn
                        :disabled="disablePrefixes"
                        class="primary elevation-1"
                        @click="editingPrefix(prefix)">
                        {{$lang.actions.edit}}
                      </v-btn>
                      <v-btn class="error ml-0 elevation-1" @click="deletePrefix(index)">{{$lang.actions.delete}}</v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </v-flex>
        <v-btn class="primary mx-4 mt-4 mb-2" @click="addPostfix" :disabled="editPostfix" v-if="!isView">{{$lang.actions.postfixLines}}</v-btn>
        <h3 class="mt-4 mx-4" v-if="isView && postfixLines.length !== 0">{{$lang.header.postixLines}}:</h3>
        <v-flex xs12 px-3>
          <div class="v-table__overflow">
            <table class="v-datatable v-table theme--light">
              <tbody>
                <tr
                  v-for="(postfix, index) in postfixLines"
                  :key="index">
                  <template v-if="postfix.isEdit">
                    <td class="move-row" v-if="!isView"/>
                    <td class="pb-2">
                      <v-text-field
                        v-if="tempPostfix.content !== 'image'"
                        v-model="tempPostfix.fontHeight"
                        :disabled="['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(tempPostfix.content)"
                        :label="$lang.labels.fontHeight"
                        min="0"
                        type="number"
                        class="min-w"
                        required
                        hide-details
                      />
                    </td>
                    <td class="pb-2">
                      <v-select
                        v-if="tempPostfix.content !== 'image'"
                        v-model="tempPostfix.fontStyle"
                        :disabled="['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(tempPostfix.content)"
                        :items="fontStyles"
                        :label="$lang.labels.fontStyle"
                        class="min-w"
                        required
                        hide-details
                      />
                      <template v-else>
                        <v-text-field
                          prepend-icon="attach_file"
                          single-line
                          hide-details
                          v-model="tempPostfix.filename"
                          label="choose_file"
                          required
                          class="min-w"
                          @click="startInput('postfixFileInput')"
                          ref="fileTextField" />
                        <input style="display: none;" type="file" accept="image/*" ref="postfixFileInput" @change="onFileChange('tempPostfix', $event)">
                      </template>
                    </td>
                    <td class="pb-2">
                      <v-combobox
                        class="min-w"
                        :label="$lang.labels.content"
                        :items="lineChoices"
                        required
                        :search-input.sync="tempPostfix.content"
                        hide-details
                        v-model="tempPostfix.content"
                      />
                    </td>
                    <td class="actions px-0">
                      <v-btn
                        class="primary elevation-1"
                        :disabled="!tempPostfix.content ||
                          (tempPostfix.content !== 'image' && (!tempPostfix.fontHeight || !tempPostfix.fontStyle)) ||
                          (tempPostfix.content === 'image' && !tempPostfix.filename)"
                        @click="savePostfixEdit(postfix)">{{$lang.actions.save}}</v-btn>
                      <v-btn class="error ml-0 elevation-1" @click="closePostfixEdit(postfix)">{{$lang.actions.cancel}}</v-btn>
                    </td>
                  </template>
                  <template v-else>
                    <td class="move-row" v-if="!isView">
                      <div v-if="postfixLines.length >= 2">
                        <v-icon @click="moveUp(postfixLines, index)" v-if="index !== 0">keyboard_arrow_up</v-icon>
                        <v-icon @click="moveDown(postfixLines, index)" v-if="index != postfixLines.length - 1">keyboard_arrow_down</v-icon>
                      </div>
                    </td>
                    <td v-if="postfix.content !== 'image'">{{ postfix.fontHeight }}</td>
                    <td :colspan="postfix.content !== 'image' ? 1 : 2">{{ postfix.content !== 'image' ? postfix.fontStyle : postfix.filename }}</td>
                    <td>{{ postfix.content }}</td>
                    <td class="actions px-0" v-if="!isView">
                      <v-btn
                        :disabled="disablePostfixes"
                        class="primary elevation-1"
                        @click="editingPostfix(postfix)">{{$lang.actions.edit}}</v-btn>
                      <v-btn class="error ml-0 elevation-1" @click="deletePostfix(index)">{{$lang.actions.delete}}</v-btn>
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
          <v-btn
            :disabled="!previewValidation"
            color="primary"
            class="mx-0 mt-4"
            @click="preview()">
            {{ $lang.actions.preview }}
          </v-btn>
        </v-flex>
        <v-layout row wrap justify-space-between class="px-2 mt-3">
          <v-text-field
            v-if="isView && createdOn"
            :label="$lang.labels.created"
            v-model="createdOn"
            readonly
            hide-details
            class="min-w max-w mx-3"
          />
          <v-text-field
            v-if="isView && modifiedOn"
            :label="$lang.labels.modified"
            v-model="modifiedOn"
            readonly
            hide-details
            class="min-w max-w mx-3"
          />
        </v-layout>
        <v-layout row wrap justify-space-between align-content-center class="mt-3 px-3">
          <v-btn
            flat class="ml-0"
            @click="$router.push({ name: 'printTemplates' })">
            <v-icon>keyboard_arrow_left</v-icon>
            {{$lang.actions.close}}
          </v-btn>
          <v-btn
            v-if="!isView"
            class="primary mx-0"
            :disabled="!valid"
            @click="submit">
            {{ isClone ? $lang.actions.createCopy : $lang.actions.create}}
          </v-btn>
        </v-layout>
      </v-form>
    </v-card>
    <v-dialog v-if="previewModal" v-model="previewModal" max-width="800">
      <preview :data="previewData" @close="previewModal = false" />
    </v-dialog>
    <v-dialog v-if="activationModal" v-model="activationModal" max-width="390">
      <activate @activate="activate" />
    </v-dialog>
    <v-dialog v-if="showImportModal" v-model="showImportModal" max-width="390">
      <import :companies="companies" :types="types" @submit="setTemplate" @close="showImportModal = false" />
    </v-dialog>
  </v-flex>
</template>

<script>
  import {DateTime} from 'luxon';

  export default {
    components: {
      preview: () => import('../modals/PreviewPrePost'),
      activate: () => import('../modals/PrintTemplateActivationModal'),
      import: () => import('../modals/PrintTemplatesImportModal'),
    },
    data: () => ({
      err: '',
      success: '',
      activationModal: false,
      valid: false,
      isView: false,
      isClone: false,
      companyLoading: true,
      companies: [],
      templates: [],
      templateId: null,
      typesLoading: true,
      types: [],
      mainaway: [],
      unpaidBill: [],
      item: [],
      tex: [],
      taxContent: '',
      label: [],
      kitchen: [],
      driver: [],
      companyId: null,
      type: '',
      contents: null,
      templateName: '',
      content: ['text', 'emptyline', 'lineseparator', 'equalseparator', 'opencashdrawer', 'cut', 'beep', 'pagebreak', 'image'],
      fontStyles: [ 'plain', 'bold', 'italic'],
      editPrefix: false,
      prefixLines: [],
      tempPrefix: {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: '',
      },
      editPostfix: false,
      postfixLines: [],
      tempPostfix: {
        fontHeight: '',
        fontStyle: '',
        content: '',
        filename: '',
        data: '',
      },
      createdOn: '',
      noOfPrints: 1,
      modifiedOn: '',
      previewModal: false,
      previewData: null,
      disablePrefixes: false,
      disablePostfixes: false,
      activateId: '',
      isLocalAdmin: false,
      showImportModal: false,
      initDone: false,
    }),
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
      companyId(newVal, oldVal) {
        if (oldVal) {
          return;
        }
        if (newVal) {
          this.fetchTemplateForCompany(newVal);
        }
      },
      'tempPostfix.content': function(val) {
        if (['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(val)) {
          this.tempPostfix.fontHeight = 6;
          this.tempPostfix.fontStyle = 'plain';
        }
      },
      'tempPrefix.content': function(val) {
        if (['cut', 'beep', 'pagebreak', 'opencashdrawer'].includes(val)) {
          this.tempPrefix.fontHeight = 6;
          this.tempPrefix.fontStyle = 'plain';
        }
      },
    },
    computed: {
      mappedCompanies() {
        return this.companies.map(company => ({
          text: `${company.name} (${company.companyStatus})`,
          value: company.id,
        }));
      },
      numberOfImages() {
        return [...this.prefixLines, ...this.postfixLines].reduce((acc, curr) => {
          return curr.content === 'image' ? acc + 1 : acc;
        }, 0);
      },
      lineChoices() {
        return this.numberOfImages <= 3 ? this.content : this.content.slice(0, this.content.length - 1);
      },
      previewValidation() {
        let valid = false;
        if (this.prefixLines.length > 0 || this.postfixLines.length > 0) valid  = true;
        if (this.editPrefix) valid = false;
        if (this.editPostfix) valid = false;
        return valid;
      },
    },
    methods: {
      activate(what) {
        if (what) {
          this.$http.post(`printtemplate/activate/${this.activateId}`)
            .then((res) => {
              if (res.body.status === 'Success') {
                this.activationModal = false;
                this.$router.push({ name: 'printTemplates' });
                return;
              }
              this.activationModal = false;
              this.err = res.body.statusText;
            }, (err) => {
              this.activationModal = false;
              this.err = err.body.statusText || err.body.message;
            });
        } else {
          this.activationModal = false;
          this.$router.push({ name: 'printTemplates' });
        }
      },
      preview() {
        this.previewData = {
          prefixLines: this.prefixLines,
          postfixLines: this.postfixLines,
        };
        this.previewModal = true;
      },
      getFormData(files) {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(files[0]);
          reader.onload = function () {
            resolve(reader.result);
          };
          reader.onerror = function (error) {
            resolve(null);
          };
        });
      },
      async onFileChange(name, $event) {
        const files = $event.target.files || $event.dataTransfer.files
        if (files && files[0]) {
          const data = await this.getFormData(files);
          if (data === null) {
            this.err = 'Failed to convert image';
            return;
          }
          if (files[0].size > 512000) {
            this.err = 'The selected images is beyond limit of 512 KB.'
            this.$set(this[name], 'filename', '');
            this.$set(this[name], 'data', '');
            return;
          }
          const img = new Image();
          img.src = window.URL.createObjectURL(files[0]);
          img.onload = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;
            window.URL.revokeObjectURL( img.src );
            if( width > 800 || height > 600 ) {
              this.err = 'The maximum allowed resolution is 800 x 600.'
              this.$set(this[name], 'filename', '');
              this.$set(this[name], 'data', '');
              return;
            }
            this.$set(this[name], 'filename', files[0].name);
            this.$set(this[name], 'data', data);
          };
        } else {
          this.$set(this[name], 'filename', '');
          this.$set(this[name], 'data', '');
        }
      },
      startInput(name) {
        this.$refs[name][0].click();
      },
      moveUp(arr, id) {
        const y = id--;
        var origin = arr[id]
        arr.splice(id, 1, arr[y])
        this.$set(arr, y, origin);
      },
      moveDown(arr, id) {
        const y = id++;
        var origin = arr[id]
        arr.splice(id, 1, arr[y])
        this.$set(arr, y, origin);
      },
      populate() {
        const template = this.templates.find(e => e.id === this.templateId)
        this.prefixLines = template.printPrefix;
        this.postfixLines = template.printPostfix;
      },
      formatDate(date) {
         return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      //PREFIX
      addPrefix() {
        this.prefixLines.push({
          fontHeight: '',
          fontStyle: '',
          content: '',
          filename: '',
          data: '',
          isEdit: true,
        });
        this.disablePrefixes = true;
        this.editPrefix = true;
        this.$forceUpdate();
      },
      editingPrefix(prefix) {
        this.disablePrefixes = true;
        this.tempPrefix = {
          fontHeight: prefix.fontHeight,
          fontStyle: prefix.fontStyle,
          content: prefix.content,
          filename: prefix.filename,
          data: prefix.data,
        };
        this.$set(prefix, 'isEdit', true);
        this.editPrefix = true;
      },

      deletePrefix(index) {
        this.prefixLines.splice(index, 1);
        this.$forceUpdate();
      },

      savePrefixEdit(prefix) {
        this.disablePrefixes = false;
        this.$set(prefix, 'fontHeight', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPrefix.content) ?
          6 : this.tempPrefix.fontHeight);
        this.$set(prefix, 'fontStyle', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPrefix.content) ?
          'plain' : this.tempPrefix.fontStyle);
        this.$set(prefix, 'content', this.tempPrefix.content);
        this.$set(prefix, 'filename', this.tempPrefix.filename);
        this.$set(prefix, 'data', this.tempPrefix.data);
        this.closePrefixEdit(prefix);
      },

      closePrefixEdit(prefix) {
        this.tempPrefix = {
          fontHeight: '',
          fontStyle: '',
          content: '',
          filename: '',
          data: '',
        };
        this.$set(prefix, 'isEdit', false);
        this.disablePrefixes = false;
        this.editPrefix = false;
      },
      //POSTFIX
      addPostfix() {
        this.postfixLines.push({
          fontHeight: '',
          fontStyle: '',
          content: '',
          filename: '',
          data: '',
          isEdit: true,
        });
        this.disablePostfixes = true;
        this.editPostfix = true;
        this.$forceUpdate();
      },
      editingPostfix(postfix) {
        this.disablePostfixes = true;
        this.tempPostfix = {
          fontHeight: postfix.fontHeight,
          fontStyle: postfix.fontStyle,
          content: postfix.content,
          filename: postfix.filename,
          data: postfix.data,
        };
        this.$set(postfix, 'isEdit', true);
        this.editPostfix = true;
      },

      deletePostfix(index) {
        this.postfixLines.splice(index, 1);
        this.$forceUpdate();
      },

      savePostfixEdit(postfix) {
        this.disablePostfixes = false;
        this.$set(postfix, 'fontHeight', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPostfix.content) ?
          6 : this.tempPostfix.fontHeight);
        this.$set(postfix, 'fontStyle', ['image', 'beep', 'pagebreak', 'opencashdrawer'].includes(this.tempPostfix.content) ?
          'plain' : this.tempPostfix.fontStyle);
        this.$set(postfix, 'content', this.tempPostfix.content);
        this.$set(postfix, 'filename', this.tempPostfix.filename);
        this.$set(postfix, 'data', this.tempPostfix.data);
        this.closePostfixEdit(postfix);
      },

      closePostfixEdit(postfix) {
        this.tempPostfix = {
          fontHeight: '',
          fontStyle: '',
          content: '',
          filename: '',
          data: '',
        };
        this.disablePostfixes = false;
        this.$set(postfix, 'isEdit', false);
        this.editPostfix = false;
      },

      init() {
        return new Promise((resolve) => {
          this.$http.get('company')
            .then((res) => {
              resolve();
              this.companyLoading = false;
              if (res.body.status === 'Success') {
                this.companies = res.body.companies;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.companyLoading = false;
              this.err = err.body.statusText || err.body.message;
            });

            this.$http.get('system/printtemplatetypes')
            .then((res) => {
              resolve();
              this.typesLoading = false;
              if (res.body.status === 'Success') {
                this.types = res.body.printTemplateTypes;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.typesLoading = false;
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/mainaway')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.mainaway = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/unpaidbill')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.unpaidBill = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/item')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.item = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/tax')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.tax = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/label')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.label = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
            this.$http.get('printtemplate/fetchalltemplatecontents/kitchen')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.kitchen = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
          this.$http.get('printtemplate/fetchalltemplatecontents/driver')
            .then((res) => {
              resolve();
              if (res.body.status === 'Success') {
                this.driver = res.body.details;
                return;
              }
              this.err = res.body.statusText;
            }, (err) => {
              resolve();
              this.err = err.body.statusText || err.body.message;
            });
        });
      },
      submit() {
        const data = {
          companyId: this.companyId,
          type: this.type,
          contents: [this.contents],
          templateName: this.templateName,
          printPostfixArray: this.postfixLines,
          printPrefixArray: this.prefixLines,
          printPrefix: Object.assign({}, this.prefixLines),
          printPostfix: Object.assign({}, this.postfixLines),
          noOfPrints: this.noOfPrints,
        };
        if (this.type === 'invoice') {
          data.contents.push(this.taxContent);
        }
        this.$http.post('printtemplate/create', data)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.success = 'Print Template created successfuly';
              setTimeout(() => {
                if (this.isView) {
                  this.success = '';
                } else {
                  this.activateId = res.body.printTemplateId;
                  this.activationModal = true;
                }
              }, 500);
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      fetchTemplateForCompany(id, forImport = false) {
        if (!forImport) this.templates = [];
        this.$http.post('printtemplate/fetchall', { companyId: id })
          .then((res) => {
            if (res.body.status === 'Success') {
              if (forImport) {
                this.templatesForImport = res.body.details;
                return;
              }
              this.templates = res.body.details;
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      setTemplate(findPrintTemplate) {
        if (findPrintTemplate) {
          this.type = findPrintTemplate.type;
          const contents = findPrintTemplate.contents;
          const taxTemplate = findPrintTemplate.contents.findIndex(template => template.includes('tax'));
          if (taxTemplate !== -1) {
            this.taxContent = contents[taxTemplate];
            contents.splice(taxTemplate, 1);
          }
          [this.contents] = contents;
          this.templateName = findPrintTemplate.templateName;
          this.prefixLines = findPrintTemplate.printPrefix;
          this.postfixLines = findPrintTemplate.printPostfix;
          this.noOfPrints = findPrintTemplate.noOfPrints || 1;
          this.showImportModal = false;
        }
      },
    },
    created() {
      const roles = JSON.parse(this.$cookie.get('roles') || '[]');
      this.isLocalAdmin = roles.includes('ROLE_SUN_LOCAL_ADMIN');
      this.init()
        .then(() => {
          this.initDone = true;
          if (this.$route.params.id && this.$route.params.view) {
            this.isView = true;
          }
          if (this.$route.params.id) {
            this.isClone = true;
            this.$http.get(`printtemplate/getbyid/${this.$route.params.id}`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  const data = res.body.templateDetails;
                  this.companyId = data.companyId;
                  this.type = data.type;
                  const contents = data.contents;
                  const taxTemplate = data.contents.findIndex(template => template.includes('tax'));
                  if (taxTemplate !== -1) {
                    this.taxContent = contents[taxTemplate];
                    contents.splice(taxTemplate, 1);
                  }
                  [this.contents] = contents;
                  this.templateName = data.templateName;
                  this.prefixLines = data.printPrefix;
                  this.postfixLines = data.printPostfix;
                  this.noOfPrints = data.noOfPrints || 1;
                  this.createdOn = this.formatDate(data.createdOn);
                  if (data.modifiedOn) {
                    this.modifiedOn = this.formatDate(data.modifiedOn);
                  }
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
            }
        })
    },
  };
</script>

<style lang="scss" scoped>
  .d-none {
    display: none !important;
  }
  .move-row {
    padding: 0 12px !important;
    width: 30px !important;
  }
  .actions {
    width: 250px;
    text-align: center;
  }
  tr {
    &:nth-of-type(odd){
      background-color: #f9f9f9;
    }
  }
  td {
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
</style>



// WEBPACK FOOTER //
// PrintTemplateDetails.vue?e5eebfdc